module.exports = __webpack_public_path__ + "static/media/light_ru.edf88426.svg";